export default "__VITE_ASSET__C1eRjf4n__"